import { Tooltip } from "@chakra-ui/react";
import type { SuspectRowData } from "./table-data";

interface DisplayNameCellProps {
  value: string;
  data: SuspectRowData;
}

export function DisplayNameCellRenderer({ value, data }: DisplayNameCellProps) {
  return (
    <Tooltip label={data.logicTooltip} placement="top" hasArrow>
      <span style={{ cursor: "help", textDecoration: "underline", textDecorationStyle: "dotted" }}>
        {value}
      </span>
    </Tooltip>
  );
}
